
import { defineComponent } from 'vue';
import commonMessages from '@/locales/common';
export default defineComponent({
  name: 'NoCertificatForm',
  i18n: {
    sharedMessages: commonMessages,
  },
  data() {
    return {
      noCertificatLocal: '',
      noCodeCertificatLocal: '',
    };
  },
  methods: {
    emitNoCertificat() {
      this.$emit('updateNoCertificat', this.noCertificatLocal);
    },
    emitNoCodeCertificat() {
      this.$emit('updateNoCodeCertificat', this.noCodeCertificatLocal);
    },
  },
  mounted() {
    this.emitNoCertificat();
    this.emitNoCodeCertificat();
  },

  emits: ['updateNoCertificat','updateNoCodeCertificat'],
});
